export default {
  apis: [],
  api: {},
  loading: false,
};
